export default (cookieName: string) => {
  const [matched, cookieValue] = document.cookie.match(new RegExp(`${cookieName}=([^;]+)`)) || [
    false,
    null,
  ];
  return matched ? cookieValue : null;
};
